import { useState } from "react";
import { useNewAgent } from "../../contexts/NewAgentContext";
import { Dialog } from "components/dialog";
import { X } from "lucide-react";
import { LibraryDialogContent } from "components/file-system/LibraryDialogContent";
import { FileSystemItem } from "types";
import { useTranslation } from "hooks/useTranslation";
import { Library } from "constants/library";

const ChooseWorkflow = () => {
  const { formData, setFormData } = useNewAgent();
  const [isLibraryOpen, setIsLibraryOpen] = useState(false);
  const [selectedWorkflows, setSelectedWorkflows] = useState<FileSystemItem[]>([]);
  const { t } = useTranslation();

  const handleSelect = (selectedItems: FileSystemItem[]) => {
    setSelectedWorkflows(selectedItems);
    setFormData((prev) => ({
      ...prev,
      workflows: selectedItems.map((item) => item.id),
    }));
  };

  const handleRemoveWorkflow = (workflowId: string) => {
    const newSelectedWorkflows = selectedWorkflows.filter(
      (wf) => wf.id !== workflowId
    );
    setSelectedWorkflows(newSelectedWorkflows);
    setFormData((prev) => ({
      ...prev,
      workflows: newSelectedWorkflows.map((item) => item.id),
    }));
  };

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      <div className="flex flex-col gap-4">
        <Dialog
          trigger={
            <button
              type="button"
              onClick={() => setIsLibraryOpen(true)}
              className="h-[40px] rounded-md bg-white px-4 py-2 text-sm font-semibold text-gray-900 transition dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100"
            >
              {t('agents.newAgent.selectFromWorkflows')}
            </button>
          }
          header={t('agents.newAgent.selectWorkflowsFromLibrary')}
          isOpen={isLibraryOpen}
          setIsOpen={setIsLibraryOpen}
        >
          <LibraryDialogContent
            selectedItems={selectedWorkflows}
            handleConfirm={handleSelect}
            setIsLibraryOpen={setIsLibraryOpen}
            rootFolderName={Library.WORKFLOWS}
            selectionMode="file" // or "folder" if you want to select folders
          />
        </Dialog>

        <div className="mt-4">
          {selectedWorkflows.length > 0 ? (
            <div className="grid max-h-[40vh] gap-4 overflow-auto">
              {selectedWorkflows.map((item) => (
                <div
                  key={item.id}
                  className="flex h-20 items-center justify-between rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-900"
                >
                  <div className="flex items-center space-x-3">
                    <div>
                      <div className="font-medium text-gray-900 dark:text-gray-100">
                        {item.name}
                      </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => handleRemoveWorkflow(item.id)}
                    className="text-gray-400 hover:text-gray-500 dark:text-gray-500 dark:hover:text-gray-300"
                  >
                    <X className="h-5 w-5" />
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex items-center justify-center py-10 text-center">
              <p className="text-sm text-gray-500 dark:text-gray-400">
                {t('agents.newAgent.noWorkflowsSelected')}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChooseWorkflow;
